import * as React from "react";
import type { SVGProps } from "react";

const SvgAmex = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={34}
    viewBox="0 0 48 34"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#016FD0"
        d="M0 2.16C0 .967.97 0 2.165 0h43.19c1.196 0 2.165.973 2.165 2.16v28.8c0 1.193-.97 2.16-2.165 2.16H2.165A2.167 2.167 0 0 1 0 30.96z"
      />
      <path
        fill="#FFF"
        d="M9.23 25.049v-7.388h7.865l.844 1.094.871-1.094h28.545v6.878s-.747.503-1.61.51H29.939l-.951-1.165v1.165h-3.117v-1.988s-.426.277-1.347.277h-1.06v1.711h-4.72l-.843-1.118-.855 1.118zM.047 12.093 1.821 7.98h3.067l1.006 2.304V7.98h3.812l.6 1.665.58-1.665H28v.837s.9-.837 2.378-.837l5.553.02.99 2.273V7.98h3.19l.878 1.306V7.98h3.22v7.388h-3.22l-.842-1.31v1.31H35.46l-.472-1.164h-1.26l-.464 1.164h-3.178a3.15 3.15 0 0 1-2.086-.82v.82h-4.793l-.951-1.164v1.164H4.433l-.47-1.164H2.705l-.468 1.164H.048v-3.275z"
      />
      <path
        fill="#016FD0"
        fillRule="nonzero"
        d="M2.448 8.891.057 14.423h1.557l.441-1.108h2.566l.439 1.108h1.59L4.261 8.89zm.885 1.287.782 1.936H2.55z"
      />
      <path
        fill="#016FD0"
        d="M6.816 14.422V8.89l2.213.008 1.287 3.567 1.256-3.575h2.196v5.532h-1.391v-4.076l-1.473 4.076h-1.22l-1.478-4.076v4.076zm7.903 0V8.89h4.537v1.237h-3.132v.947h3.059v1.164h-3.059v.983h3.132v1.201z"
      />
      <path
        fill="#016FD0"
        fillRule="nonzero"
        d="M20.06 8.891v5.532h1.391v-1.965h.585l1.667 1.965h1.7l-1.83-2.038a1.69 1.69 0 0 0 1.525-1.7c0-1.163-.918-1.794-1.943-1.794zm1.391 1.237h1.59c.38 0 .658.297.658.583 0 .367-.36.582-.638.582h-1.61z"
      />
      <path
        fill="#016FD0"
        d="M27.085 14.422h-1.419V8.89h1.419zm3.366 0h-.306c-1.483 0-2.383-1.162-2.383-2.743 0-1.62.89-2.789 2.763-2.789h1.536v1.31h-1.593c-.76 0-1.297.59-1.297 1.492 0 1.072.615 1.522 1.5 1.522h.366z"
      />
      <path
        fill="#016FD0"
        fillRule="nonzero"
        d="m33.477 8.891-2.392 5.532h1.557l.441-1.108h2.566l.44 1.108h1.59L35.29 8.89zm.885 1.287.782 1.936h-1.567z"
      />
      <path
        fill="#016FD0"
        d="M37.842 14.422V8.89h1.768l2.257 3.476V8.89h1.39v5.532h-1.71l-2.315-3.567v3.567zm-27.66 9.681v-5.532h4.537v1.237h-3.132v.947h3.059v1.164h-3.059v.983h3.132v1.201zm22.231 0v-5.532h4.536v1.237h-3.131v.947h3.044v1.164h-3.044v.983h3.131v1.201zm-17.518 0 2.209-2.732-2.262-2.8h1.752l1.347 1.731 1.351-1.731h1.683l-2.231 2.766 2.213 2.766h-1.752l-1.308-1.704-1.276 1.704z"
      />
      <path
        fill="#016FD0"
        fillRule="nonzero"
        d="M21.122 18.572v5.532h1.427v-1.747h1.463c1.238 0 2.177-.654 2.177-1.925 0-1.052-.736-1.86-1.996-1.86zm1.427 1.25h1.54c.4 0 .687.245.687.638 0 .369-.285.637-.69.637h-1.537v-1.274zm4.244-1.252v5.533h1.39v-1.966h.585l1.667 1.966h1.7l-1.83-2.038a1.69 1.69 0 0 0 1.525-1.7c0-1.164-.918-1.794-1.943-1.794h-3.094zm1.39 1.238h1.59c.38 0 .658.297.658.583 0 .367-.36.582-.638.582h-1.61z"
      />
      <path
        fill="#016FD0"
        d="M37.593 24.103v-1.201h2.783c.411 0 .59-.222.59-.464 0-.233-.178-.468-.59-.468h-1.258c-1.093 0-1.701-.662-1.701-1.657 0-.887.557-1.742 2.181-1.742h2.708l-.586 1.245h-2.34c-.448 0-.586.233-.586.456 0 .23.17.483.513.483h1.317c1.218 0 1.747.687 1.747 1.587 0 .968-.59 1.76-1.814 1.76zm5.103 0v-1.201h2.783c.411 0 .59-.222.59-.464 0-.233-.178-.468-.59-.468H44.22c-1.093 0-1.701-.662-1.701-1.657 0-.887.557-1.742 2.181-1.742h2.708l-.586 1.245h-2.341c-.448 0-.586.233-.586.456 0 .23.17.483.512.483h1.318c1.218 0 1.747.687 1.747 1.587 0 .968-.59 1.76-1.814 1.76h-2.963z"
      />
    </g>
  </svg>
);
export default SvgAmex;
